const dropOffTypeLabels = {
  meetAtDoor: 'Encontrarse en la puerta',
  meetOutside: 'Encontrarse afuera',
  leaveAtDoor: 'Dejar el paquete en conserjería o en la puerta si es una casa'
}

export default dropOffTypeLabels
